// src/index.tsx
import * as React from "react";
var GarnishContext = React.createContext({});
var GarnishProvider = ({
  theme = {},
  children
}) => {
  return /* @__PURE__ */ React.createElement(GarnishContext.Provider, {
    value: theme
  }, children);
};
var useGarnish = (values) => {
  const theme = React.useContext(GarnishContext);
  const styles = React.useMemo(() => {
    const styles2 = {};
    let key;
    for (key in values) {
      const val = theme[key] || values[key];
      if (val) {
        styles2[key] = val;
      }
    }
    return styles2;
  }, [values]);
  return styles;
};
export {
  GarnishProvider,
  useGarnish
};
